import React, { useEffect, useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { KnockOrderItemType } from '../../../controller/OrderController';
import { CurrentStoreContext } from '../../../controller/StoreController';
import moment from 'moment-timezone';
import ChatDetailModal from '../../../components/modal/ChatDetailModal';
import ConciergeController, {
  CHAT_SENDER_HOTEL,
  ConciergeChatDetailType,
  ConciergeChatType,
} from '../../../controller/ConciergeController';
import { useRecoilValue } from 'recoil';
import { fcmConciergeState, FcmConciergeType } from '../../../recoil/fcmMessage';

type ChatProps = {
  chat: ConciergeChatType;
  isMobile: boolean;
  status: number;
  getConciergeRequestList: any;
};

const ChatItem = ({ chat, isMobile, status, getConciergeRequestList }: ChatProps) => {
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [chatDetail, setChatDetail] = useState<ConciergeChatDetailType[]>([]);
  const [visibleDetail, setVisibleDetail] = useState<boolean>(false);

  const messageFlag = useRecoilValue<FcmConciergeType>(fcmConciergeState);

  const getConciergeRequestDetail = async (conciergeId?: number) => {
    try {
      const oParams = {
        store_id: currentStore.value,
        concierge_id: conciergeId ? conciergeId : chat.conciergeId,
        accessor: CHAT_SENDER_HOTEL,
      };
      const oResponse = await ConciergeController.getConciergeRequestDetail(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          setChatDetail([...oRes.data.chat]);
          setVisibleDetail(true);
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  useEffect(() => {
    if (visibleDetail) {
      getConciergeRequestList();
    }
  }, [visibleDetail]);

  useEffect(() => {
    if (visibleDetail) {
      getConciergeRequestDetail(messageFlag.clientUserId);
    }
  }, [messageFlag]);

  const RenderOrderInfo = useMemo(() => {
    return (
      <div
        className="orderList"
        onClick={() => {
          if (isMobile) {
            getConciergeRequestDetail();
          }
        }}>
        <div className="row">
          <div className="room">
            <h3>{chat.name}</h3>
            {chat.hotelUnreadMessageCount > 0 && (
              <div className="roomCount">
                <p>{chat.hotelUnreadMessageCount}</p>
              </div>
            )}
          </div>
          <h4>{chat.latestContent}</h4>
        </div>
        <div className="row">
          <h5>{moment(chat.latestChatTime).format('HH:mm')}</h5>
          <button className={`stateButton `} onClick={() => getConciergeRequestDetail()}>
            <div className="buttonComment">
              <h3>답변하기</h3>
            </div>
          </button>
        </div>
      </div>
    );
  }, [chat]);

  return (
    <>
      <Style>
        <div className="orderListWrap">{RenderOrderInfo}</div>
      </Style>
      {chatDetail.length > 0 && (
        <ChatDetailModal
          isVisible={visibleDetail}
          setVisible={setVisibleDetail}
          roomName={chat.name}
          chatDetail={chatDetail}
          isMobile={isMobile}
          chat={chat}
          currentStore={currentStore}
          setChatDetail={setChatDetail}
          status={status}
        />
      )}
    </>
  );
};

export default ChatItem;

const Style = styled.div`
  .orderList {
    display: flex;
    padding: 32px 0;
    margin: 0 8%;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    border-bottom: 1px solid #e5e5e5;
    .row {
      gap: 30px;
    }
  }

  h4 {
    display: -webkit-box;
    font-size: 18px;
    line-height: 22px;
    font-weight: 400;
    color: #979797;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
  }
  h5 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    color: #979797;
  }

  .room {
    position: relative;
    min-width: 90px;
    min-height: 90px;
    max-width: 90px;
    max-height: 90px;
    background: #f7f7f7;
    border: 1px solid #4dd2ae;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    h3 {
      font-weight: 500;
      color: #4dd2ae;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .roomCount {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ff6060;
      border-radius: 100px;
      p {
        font-size: 12px;
        line-height: 12px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .stateButton {
    position: relative;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 20px;
    outline: none;
    box-shadow: 2px 2px 2px 0px #00000040;
    background: #4dd2ae;
    border: none;
    cursor: pointer;
    h3 {
      font-size: 18px;
      line-height: 24px;
      color: #ffffff;
      font-weight: 600;
    }
  }

  @media (max-width: 900px) {
    .orderList {
      position: relative;
      padding: 16px 24px 16px 10px;
      margin: 10px;
      gap: 0;
      border: 1px solid #e5e5e5;
      border-radius: 10px;
      cursor: pointer;
      .row {
        gap: 12px;
      }
    }

    h4 {
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      color: #555555;
    }
    h5 {
      position: absolute;
      font-size: 12px;
      line-height: 14px;
      text-align: right;
      top: 10px;
      right: 24px;
    }

    .room {
      min-width: 72px;
      min-height: 72px;
      max-width: 72px;
      max-height: 72px;
      h3 {
        font-size: 18px;
      }
      .roomCount {
        position: absolute;
        width: 20px;
        height: 20px;
        p {
          font-size: 10px;
          line-height: 10px;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }

    .stateButton {
      display: none;
    }
  }
`;
